interface UnitValues {
  [x: string]: string | number | boolean;
  [x: number]: string | number | boolean;
}

const BASE_UNITS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 12, 14, 18, 20, 24];
const DEFAULT_MULTIPLIER = 4;
export const UNITS = {
  PX: 'px',
};

/**
 * Function that generate stitches units based on an array of numbers, a multiplier and an optional unit.
 **/
export function generateUnits(
  arrayMultiplier = BASE_UNITS,
  multiplier = DEFAULT_MULTIPLIER,
  unit = UNITS.PX,
): UnitValues {
  const units: UnitValues = {};

  arrayMultiplier.forEach((item) => {
    units[item] = `${item * multiplier}${unit}`;
  });

  return units;
}
